module.exports = __webpack_public_path__ + "img/achiote_menu2.d3cba011.png";